import api from './client';

export interface Player {
  id: string;
  username: string;
  coins: number;
  is_admin: boolean;
  has_character: boolean;
  grade: number | null;  // 0=K, 1-5 for grades 1-5
  league_id: string | null;  // ID of player's league
  onboarding_completed: boolean;
  placement_completed: boolean;
  team_image_url: string | null;
}

export const register = async (username: string, password: string, grade: number) => {
  const res = await api.post('/api/auth/register', { username, password, grade });
  return res.data;
};

export const login = async (username: string, password: string) => {
  const res = await api.post('/api/auth/login', { username, password });
  return res.data;
};

export const getMe = async (): Promise<Player> => {
  const res = await api.get('/api/auth/me');
  return res.data;
};

export const completeOnboarding = async () => {
  await api.post('/api/auth/onboarding-complete');
};

export const logout = async () => {
  await api.post('/api/auth/logout');
  localStorage.removeItem('token');
};

// Google SSO types
export interface NeedsRegistrationResponse {
  needs_registration: true;
  session_token: string;
  email: string;
  name: string;
}

export interface GoogleAuthTokenResponse {
  access_token: string;
  token_type: string;
}

export type GoogleAuthResponse = NeedsRegistrationResponse | GoogleAuthTokenResponse;

export const googleAuth = async (
  idToken?: string,
  grade?: number,
  sessionToken?: string
): Promise<GoogleAuthResponse> => {
  const res = await api.post('/api/auth/google', {
    id_token: idToken,
    session_token: sessionToken,
    grade,
  });
  return res.data;
};
